
/**
 * @param {string} hash
 */
export async function cleanCache (hash) {
  if (window.caches) {
    const keys = await caches.keys();
    // Wait for the deletes, callers reload right after
    await Promise.all(keys.filter(x => x.startsWith(hash))
      .map(key => caches.delete(key)));
  }
}

export async function unregisterSW () {
  if (navigator.serviceWorker) {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) await registration.unregister();
  }
}

export function reloadAppRoot () {
  // Will drop hash off
  const { protocol, host, pathname, search } = location;
  // Replace so that no risk of back navigation rises
  location.replace(`${protocol}//${host}${pathname}${search}`);
}